import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import Loadfirst from './Loadfirst';
import { AuthProvider } from "./AuthContext";
import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <Loadfirst />
      </AuthProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
